module.exports = __webpack_public_path__ + "static-portal/img/register-1.0a3a144.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/register-1.jpg
// module id = rOYg
// module chunks = 4